import React, { createContext, ReactNode, useContext } from 'react';

export type IPricingContextProps = {
  shouldShowPricingBookPage: boolean;
};

const PricingContext = createContext<IPricingContextProps | null>(null);

interface IPricingProviderProps {
  children: ReactNode;
  shouldShowPricingBookPage: boolean;
}

const PricingProvider: React.FC<IPricingProviderProps> = ({
  children,
  shouldShowPricingBookPage,
}) => {
  return (
    <PricingContext.Provider value={{ shouldShowPricingBookPage }}>
      {children}
    </PricingContext.Provider>
  );
};

const usePricingContext = (): IPricingContextProps => {
  const context = useContext(PricingContext);
  if (!context) {
    throw new Error('usePricingContext must be used within PricingProvider');
  }
  return context;
};

export { PricingProvider, PricingContext, usePricingContext };
